import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ModalWindow } from 'libs.nucleus';
import { ConsentElementConfigForm } from './consent_element_config_form.component';
export const ConsentElementConfigModal = ({ element, isOpen, onClose, onSave, }) => {
    if (!element) {
        return _jsx(_Fragment, {});
    }
    const handleSave = (updatedElement) => {
        onSave(updatedElement);
        onClose();
    };
    return (_jsx(ModalWindow, { title: `Configure ${element.type.replace('_', ' ')} Element`, isOpen: isOpen, closeWindow: onClose, children: _jsx(ConsentElementConfigForm, { element: element, onSave: handleSave, onCancel: onClose, showCancel: true, inline: true }) }));
};
